import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const getMerchantRequestBody = (mid: string, parentSettlement?: string) => {
  return {
    mid: mid,
    parentSettlement,
    status: 'ACTIVE',
  }
}

export interface MerchantData {
  mid: string
  terminalId?: string
  vpa: string
  mobile?: string
  program_identifier?: string
  tr_identifier?: string
  sequence_flag?: string
  intentId?: string
  status?: 'ACTIVE' | 'INACTIVE'
  firstName?: string
  lastName?: string
  parentSettlement?: string
  config?: string
  configList?: string
  vpa_prefix?: string
}

const insertMerchant = (merchantData: MerchantData, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.insertMerchant,
    body: getMerchantRequestBody(merchantData.mid, merchantData.parentSettlement),
    method: 'POST',
  }
  return executeRequest(request).then((data) => {
    if (data?.data?.status === 'SUCCESS') {
      return data?.data
    } else {
      throw data
    }
  })
}

export { insertMerchant }
